import Validator from '../validator';

Validator.register('required', <T>(value: T) => {
  if (Array.isArray(value) && value.length === 0) {
    return 'Cannot be blank';
  }
  if (value === null || value === undefined || value === '') {
    return 'Cannot be blank';
  }
  return null;
});
